<template>
  <div class="loginbody loading-area" id="loginbody">
    <div class="loginbody-bg">
      <div class="logo-name">
        <!-- <p>韶关市武江区智慧停车管理平台</p> -->
        <p>{{systemConfig.PLATFORM_NAME}}</p>
        <p>Intelligent parking management expert</p>
      </div>
      <form action="#" method="post">
        <!-- <div class="loginbox clearfix">
				  
                <div class='input'>
                    <ul>
                        <li class="logins" v-bind:class='{loginsBorder:isFocus}'>
                            <input type="text" autofocus="autofocus" class="loginuser" id="username" name="" v-model="loginForm.username"  @focus='isFocus=true' @blur='isFocus=false'/>
                        </li>
                        <li class="form_tip" id=""></li>
                        <li class="logins loginpsd" v-bind:class='{loginspsdBorder:isFocuspsd}'>
                            <input type="password" class="loginpwd" id="password" name="password" v-model="loginForm.password" @focus='isFocuspsd=true' @blur='isFocuspsd=false' />

                        </li>
                      <li class="reset clearfix dn">
                            <div class="fl backpsd">
                                <a href="./code.html">找回密码</a>
                            </div>
                            <div class="fr register">
                                <a href="./register.html">新用户注册</a>
                            </div>
                        </li>
                        <li class="form_tip" id=""></li>
                        <li style="text-align:center;">
                            <button type="button" class="btnlogin" id="login" name="#" @click="submitForm" @keyup="handleKeydown($event)">登&nbsp;&nbsp;录</button>
                        </li>
                    </ul>
                </div>
				
        </div>-->
        <div class="loginbox">
          <div class="input">
            <ul>
              <li class="logins">
                <!-- <li class="logins" v-bind:class='{loginsBorder:isFocus}'> -->
                <input
                  type="text"
                  autofocus="autofocus"
                  class="loginuser"
                  id="username"
                  name
                  v-model="loginForm.username"
                  @focus="isFocus = true"
                  @blur="isFocus = false"
                  autocomplete="off"
                  v-noBlankSpace
                />
              </li>
              <li class="form_tip" id></li>
              <li class="logins loginpsd">
                <!-- <li class="logins loginpsd" v-bind:class='{loginspsdBorder:isFocuspsd}'> -->
                <input
                  type="password"
                  class="loginpwd"
                  id="password"
                  name="password"
                  v-model="loginForm.password"
                  @focus="isFocuspsd = true"
                  @blur="isFocuspsd = false"
                  autocomplete="off"
                  v-noBlankSpace
                />
              </li>
              <li class="form_tip" id></li>
              <li class="remember-psd" id>
                <el-checkbox v-model="loginForm.checked"
                  >记住用户名和密码</el-checkbox
                >
              </li>
              <li class="form_tip" id></li>
              <li style="text-align: center">
                <button
                  type="button"
                  class="btnlogin"
                  id="login"
                  name="#"
                  @click="submitForm"
                  @keyup="handleKeydown($event)"
                >
                  登&nbsp;&nbsp;录
                </button>
              </li>
            </ul>
          </div>
        </div>
      </form>
    </div>
    <div class="beian">
      <a href="http://beian.miit.gov.cn" target="_blank"
        >ICP备案号：粤ICP备09038892号</a
      >
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import Cookies from "js-cookie";
import axios from "axios";
import md5 from "js-md5";
import { mapActions, mapState } from "vuex";
import { login_url } from "../api/url.js";
import systemConfig from '@/utils/globalVal.js'
export default {
  data() {
    return {
      systemConfig:{},
      loginForm: {
        username: "",
        password: "",
        checked: false,
      },
      msg: {
        error: "用户名或密码错误",
        empty: "用户名或密码为空",
      },
      isFocus: true,
      isFocuspsd: false,
      applicationType: "outside",
    };
  },
  created: function () {
    console.log('router=>',this.$router)
    console.log("route=>",this.$route)
    document.getElementById("appLoading").style.display = "none";
    console.log('systemConfig=>',systemConfig)
    this.systemConfig=systemConfig
    let _this = this;
    document.onkeydown = function (e) {
      let _key = window.event.keyCode;
      if (_key === 13) {
        document.onkeydown = "";
        _this.submitForm();
      }
    };
    if (Cookies.get("checkedOutside") == 1) {
      this.loginForm.username = Cookies.get("usernameOutside");
      let password = Cookies.get("passwordOutside");
      this.loginForm.password = Base64.decode(password);
      let checkedTemp = Cookies.get("checkedOutside");
      if (checkedTemp == 1) {
        this.loginForm.checked = true;
      } else {
        this.loginForm.checked = false;
      }
    }
  },
  mounted() {
    this.setSubmenuList([]);
    this.setMainMenuMovePlace({ place: 172 });
    this.setCurrentMovePlace({ place: 0 });
  },
  computed: {},
  methods: {
    ...mapActions(["getAdminData"]),
    ...mapActions("menu", [
      "setSubmenuList",
      "setMainMenuMovePlace",
      "setCurrentMovePlace",
    ]),
    login() {
      var _this = this;
      if (this.loginForm.username == "" || this.loginForm.password == "") {
        Message({
          message: this.msg.empty,
          type: "warning",
        });
      } else {
        //登录前清空 Authorization
        Cookies.set("Authorization", "", { path: "" });
        Cookies.set("userName", "", { path: "" });
        this.$post(login_url(), {
          grant_type: "password",
          username: this.loginForm.username,
          password: this.loginForm.password,
        })
          .then((data) => {
            //由后台返回加密后的账号，密码
            if (data.access_token === "" || data.access_token === undefined) {
              console.log("账号或密码错误！");
              Message({
                message: _this.msg.error,
                type: "warning",
              });
            } else {
              Cookies.set("Authorization", data.access_token, { path: "" });
              Cookies.set("userName", data.userName, { path: "" });
              if (this.loginForm.checked) {
                Cookies.set("usernameOutside", this.loginForm.username, {
                  expires: 7,
                });
                let password = Base64.encode(this.loginForm.password);
                Cookies.set("passwordOutside", password, { expires: 7 });
                Cookies.set("checkedOutside", 1, { expires: 7 });
              } else {
                Cookies.set("usernameOutside", this.loginForm.username);
                Cookies.remove("passwordOutside");
                Cookies.remove("checkedOutside");
              }
              _this.$router.push("/main/home");
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    logout: function () {
      var _this = this;
      axios({
        method: "delete",
        url: login_url() + "?access_token=" + Cookies.get("Authorization"),
        // data: {
        // 	access_token:"Bearer+"+Cookies.get('Authorization')
        // },
        headers: { Authorization: "Basic dnVlOnZ1ZQ==" },
      })
        .then(function (response) {
          var data = response.data;
          if (data.status == 200) {
            Cookies.remove("Authorization", { path: "" });
            if (Cookies.get("checkedOutside") != 1) {
              Cookies.remove("usernameOutside");
            }
            _this.$router.push("/");
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    async submitForm() {
      try {
        if (Cookies.get("Authorization")) {
          await this.logout();
        }
        this.login();
      } catch (error) {
        console.log(error);
      }
    },

    handleKeydown: function (ev) {
      // alert('你按回车键了');
      if (ev.keyCode == 13) {
        this.submitForm();
      }
    },
  },
  watch: {},
};
</script>

<style scoped>
@import "../assets/css/login.css";
.loginbody {
  background: #eee;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loginbody-bg {
  /* background-color:#152C72; */
  background-color: #002f55;
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: space-between;
  padding: 0 10%;
  align-items: center;
}
.loginbox {
  display: flex;
  align-items: center;
  height: 400px;
  background: white;
  width: 500px;
  border-radius: 10px;
  justify-content: center;
  box-shadow: 0 0 10px #666;
}

.input ul .logins {
  padding: 6px 2px 6px 46px;
  border: 1px solid #152c72;
  border-radius: 8px;
  background: url("../assets/images/username2.png") no-repeat 14px center;
  background-size: 20px 20px;
}

.input ul .logins input {
  width: 290px;
  height: 30px;
  padding-left: 10px;
  background: none;
  color: #152c72;
}
.input ul .loginpsd {
  margin-bottom: 4px;
  background: url("../assets/images/psd2.png") no-repeat 14px center;
  background-size: 20px 20px;
}

.reset .backpsd {
  padding-left: 20px;
  height: 20px;
  line-height: 20px;
}
.reset .register a {
  color: #589ffe;
}
.form_tip {
  height: 20px;
  line-height: 20px;
  color: #d00;
}

.input ul li .btnlogin {
  width: 80%;
  height: 44px;
  font-size: 16px;
  border-radius: 0px;
  background-color: #002f55;
  color: white;
}
.input ul li .btnlogin:hover {
  background: #034e8b;
}
.loginbm {
  height: 50px;
  line-height: 50px;
  text-align: center;

  position: absolute;
  bottom: 0;
  width: 100%;
  color: #002f55;
}

.loginbm a {
  font-weight: bold;
  color: #002f55;
}

.loginbm a:hover {
  color: #fff;
}
.input h1 {
  height: 88px;
  width: 360px;
  text-align: center;
  line-height: 88px;
}

.input h1 img {
  width: 144px;
  margin: 0 108px;
  display: inline-block;
  text-align: center;
  opacity: 1;
}

.logo-name {
  font-size: 32px;
  color: white;
  background: url("../assets/images/logo_bg.png") no-repeat 14px center;
  background-size: 100px 100px;
  padding-left: 110px;
  opacity: 0.6;
  height: 100px;
}
.logo-name p:last-child {
  font-size: 30px;
}

.remember-psd {
  color: white;
}
.footer {
  position: fixed;
  bottom: 0;
}
.footer .content {
  background: none !important;
  border-top: none !important;
}
.applicationType {
  padding: 20px;
  display: flex;
  justify-content: space-between;
}
.applicationType span {
  display: inline-block;
  font-size: 18px;
  border: #002f55 1px solid;
  width: 40%;
  height: 40px;
  border-radius: 5px;
  line-height: 40px;
  color: white;
  text-align: center;
  cursor: pointer;
  color: #002f55;
}
.applicationType span:first-child {
  margin-right: 20px;
}
.outside {
  background-color: #002f55 !important;
  color: white !important;
}
.beian {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  text-align: center;
  margin-bottom: 10px;
}
</style>
<style>
.remember-psd .el-checkbox {
  color: #002f55;
}
.remember-psd .el-checkbox__inner {
  border: 1px solid #002f55;
}
.remember-psd .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #002f55;
  border-color: #002f55;
}
.remember-psd .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #002f55;
}
.remember-psd .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #002f55;
}
.remember-psd .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #002f55;
}
</style>